import { Component, OnInit } from '@angular/core';
import { AgentService } from 'src/app/agent/services/agent.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { DashboardDataHandlerComponent } from './dashboard-data.handler';
import { Router } from '@angular/router';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { OfflineService } from 'src/app/offline/offline.service';

@Component({
  selector: 'sym-dashboard-data',
  templateUrl: './dashboard-data.component.html',
  styleUrls: ['./dashboard-data.component.scss'],
})
export class DashboardDataComponent extends DashboardDataHandlerComponent implements OnInit {
  constructor(
    public service: AgentService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService,
    public offlineService: OfflineService
  ) {
    super(service, headerService, router, settingService, offlineService);
  }
}
